import styled from 'styled-components';

const Message = styled.p`
  color: red;
  margin: 0;
`;

export { Message };
